import React from "react";

/**
 * NourNet logomark — Asir madder square block + crisp wordmark.
 * Architectural: a confident solid block, not a generic gradient hex.
 */
export const Logo = ({ size = 32, withWordmark = true, className = "", color }) => {
    const wm = color || "#1A1C1D";
    return (
        <span
            className={`inline-flex items-center gap-2.5 ${className}`}
            aria-label="NourNet"
            data-testid="brand-logo"
        >
            <svg width={size} height={size} viewBox="0 0 36 36" fill="none" aria-hidden="true">
                <rect x="2" y="2" width="32" height="32" rx="6" fill="#8A1E12" />
                <path
                    d="M11 25 V11 L25 25 V11"
                    stroke="#FAF9F6"
                    strokeWidth="2.6"
                    strokeLinecap="square"
                    strokeLinejoin="miter"
                    fill="none"
                />
                <rect x="26" y="6" width="6" height="6" fill="#E59500" />
            </svg>
            {withWordmark && (
                <span
                    style={{
                        fontFamily: "Outfit, ui-sans-serif, system-ui, sans-serif",
                        fontWeight: 700,
                        fontSize: Math.max(17, size * 0.62),
                        color: wm,
                        letterSpacing: "-0.02em",
                    }}
                >
                    NourNet
                </span>
            )}
        </span>
    );
};
